import { render, staticRenderFns } from "./relatedArea.vue?vue&type=template&id=471ee9c6&scoped=true&"
import script from "./relatedArea.vue?vue&type=script&lang=js&"
export * from "./relatedArea.vue?vue&type=script&lang=js&"
import style0 from "./relatedArea.vue?vue&type=style&index=0&id=471ee9c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ee9c6",
  null
  
)

export default component.exports